var map = {
	"./DOC.svg": 10116,
	"./DOCX.svg": 12756,
	"./GIF.svg": 90894,
	"./JPEG.svg": 96744,
	"./MOV.svg": 30956,
	"./MP4.svg": 7237,
	"./PDF.svg": 171,
	"./PNG.svg": 40633,
	"./PPTX.svg": 22658,
	"./RAR.svg": 89328,
	"./TXT.svg": 80339,
	"./XLS.svg": 63871,
	"./XLSX.svg": 32302,
	"./ZIP.svg": 95970,
	"./add-img.svg": 51786,
	"./ai.svg": 3156,
	"./alfxzj.svg": 48393,
	"./align-center.svg": 4526,
	"./align-justify.svg": 56439,
	"./align-left.svg": 98428,
	"./align-right.svg": 76977,
	"./arrow-down.svg": 41734,
	"./base.svg": 26594,
	"./blockquote.svg": 19342,
	"./bold.svg": 13444,
	"./bullet-list.svg": 94147,
	"./cbzjpgzj.svg": 63611,
	"./cicle-left.svg": 98662,
	"./cicle-right.svg": 47100,
	"./code-block.svg": 57872,
	"./file-markdown.svg": 64656,
	"./file-pdf.svg": 85606,
	"./file-word.svg": 66388,
	"./filelink.svg": 90465,
	"./font-color.svg": 30836,
	"./font-size.svg": 4610,
	"./h1.svg": 1540,
	"./h2.svg": 45862,
	"./h3.svg": 52980,
	"./h4.svg": 73898,
	"./highlight-text.svg": 3546,
	"./horizontal-max.svg": 79508,
	"./horizontal-min.svg": 30666,
	"./italic.svg": 3255,
	"./lcgf.svg": 35219,
	"./like-fill.svg": 82026,
	"./like.svg": 23671,
	"./link.svg": 4008,
	"./more.svg": 43205,
	"./msg.svg": 1263,
	"./new-chat.svg": 1626,
	"./normal.svg": 17137,
	"./ordered-list.svg": 94578,
	"./redo.svg": 32853,
	"./send.svg": 10981,
	"./sjfxgcs.svg": 6338,
	"./sjzy.svg": 67231,
	"./strike.svg": 90826,
	"./swj.svg": 66778,
	"./sws.svg": 52878,
	"./sxzxzj.svg": 48835,
	"./task-list.svg": 34815,
	"./translate.svg": 78772,
	"./triangle-down.svg": 31814,
	"./underline.svg": 79799,
	"./undo.svg": 49986,
	"./unknown.svg": 48447,
	"./unlike-fill.svg": 19599,
	"./unlike.svg": 79696,
	"./wechat.svg": 74503,
	"./yygj.svg": 35842
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 88091;